export default (theme) => ({
  buttonTabs: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 75,
  },
  tabButton: {
    justifyContent: 'flex-start',
    marginBottom: 10,
    textTransform: 'capitalize',
    fontWeight: 'bold',
    [theme.breakpoints.down('xl')]: {
      fontSize: 24,
    },
    [theme.breakpoints.down('md')]: {
      borderBottom: `1px solid ${theme.palette.disabled.main}`,
      borderRadius: 0,
      fontSize: 24,
    },
    '&:last-of-type': {
      [theme.breakpoints.down('md')]: {
        borderBottom: 'none',
      },
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
});
